import i18n from "i18next";

import { initReactI18next } from "react-i18next";
import Backend from "i18next-http-backend";
import LanguageDetector from "i18next-browser-languagedetector";
import trans from "../translation";

// translation catalog
const resources = {
  en: {
    translation: trans.enUS,
  },
  id: {
    translation: trans.id,
  },
};

// initialize i18next with catalog and language to use
i18n
  // load translation using http -> see /public/locales (i.e. https://github.com/i18next/react-i18next/tree/master/example/react/public/locales)
  // learn more: https://github.com/i18next/i18next-http-backend
  // want your translations to be loaded from a professional CDN? => https://github.com/locize/react-tutorial#step-2---use-the-locize-cdn
  .use(Backend)
  // detect user language
  // learn more: https://github.com/i18next/i18next-browser-languageDetector
  .use(LanguageDetector)
  // pass the i18n instance to react-i18next.
  .use(initReactI18next)
  // init i18next
  // for all options read: https://www.i18next.com/overview/configuration-options
  .init({
    resources,
    lngs: ["en", "id"],
    fallbackLng: "en-US",
  });

const currentLng = i18n.language;
// i18n.changeLanguage(currentLng === 'id' ? currentLng : 'en');
i18n.changeLanguage(currentLng === 'en' ? currentLng : 'id');